import { ConfigOption } from '@ngx-formly/core';
import { FormlyFieldDatePicker } from './datepicker.type';

export function withFormlyDatePicker(): ConfigOption {
  return {
    types: [
      {
        name: 'datepicker',
        component: FormlyFieldDatePicker,
        wrappers: ['form-field']
      }
    ]
  };
}